import React, { useState, useEffect, useRef } from "react";
import {
  IconButton,
  Box,
  Typography,
  CircularProgress,
  Dialog,
} from "@mui/material";



import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CategoriesScreen from "./CategoriesScreen";
import StreamerProfile from "./StreamerProfile";


import { useNavigate, useLocation } from "react-router-dom";

import Card35Video from "../../cards/Card35Video";
import Card18Image from "../../cards/Card18Image";
import Card17VideoHome from "../../cards/Card17VideoHome";
import Card17Image2 from "../../cards/Card17Image2";
import Card17ImageTextTime from "../../cards/Card17ImageTextTime";
import Card33VideoHorizontal from "../../cards/Card33VideoHorizontal";

import VideoPlayer from "./VideoPlayer"; // Importing reusable VideoPlayer component
import LoadingScreenBlackLogo from "../../common/LoadingProgressBar";
import PWAHeader from "../../common/PWAHeader";
import { fetchVideoHomeComponents1 } from "../../apiservices/ApiService";
import { fetchVideoHomeComponents } from "../../apiservices/ApiService";

const GOQiiPlayScreen = () => {
  const location = useLocation();
  const [selectedProfile, setSelectedProfile] = useState(null); // For StreamerProfile
  const navigate = useNavigate(); // Initialize navigation
  const isInitialMount = useRef(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState("home"); // Manages the current view ('home' or 'categories')
  const [selectedCategory, setSelectedCategory] = useState(null); // Tracks selected category
  const [cards, setCards] = useState([]); // Stores fetched cards
  const [isLoading, setIsLoading] = useState(false); // Loading indicator
  const [hasMore, setHasMore] = useState(true); // Check if more data is available

  const handleProfileClick = (profileData) => {
    setSelectedProfile(profileData); // Set selected profile
    setView("StreamerProfile"); // Switch to StreamerProfile view
  };

  const handleVideoClick = (videoData) => {
    setSelectedVideo(videoData); // Set the selected video data
  };

  const handleClosePlayer = () => {
    setSelectedVideo(null); // Close the player
  };

  const handleCategoryClick = (typeId, type,displayName) => {
    setSelectedCategory({ typeId, type,displayName });
    setView("categories");
  };

  const loadVideoComponents = async (pageId = 1) => {
    setIsLoading(true);
    try {
      const data = await fetchVideoHomeComponents1({ pageId});
      console.error("fetchVideoHomeComponents1 :", data);
      console.error("fetchVideoHomeComponents1 :", data?.cards);
      if (data?.cards) {
        setCards((prevCards) => [...prevCards, ...data.cards]);
        setHasMore(data.cards.length > 0);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching video components:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  };
  const fixUrlProtocol = (url) => {
    if (!url) return '';
    return url.startsWith('http:') ? url.replace(/^http:/, 'https:') : url;
  };
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      loadVideoComponents(1); // Load initial data
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100
      ) {
        if (!isLoading && hasMore) {
          const nextPage = currentPage + 1;
          setCurrentPage(nextPage);
          loadVideoComponents(nextPage);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [currentPage, isLoading, hasMore]);

  const renderCardsByTypeAndItem = (card) => {
    if (card.cardType === "17" && card.itemType === "image-text-time") {
      return (
        <Card17ImageTextTime
          card={card}
          handleProfileClick={handleProfileClick}
        />
      );
    } else if (card.cardType === "17" && card.itemType === "video_home") {
      return <Card17VideoHome card={card} />;
    } else if (card.cardType === "35" && card.itemType === "video") {
      return (
        <Card35Video
          card={card}
          handleVideoClick={handleVideoClick}
        />
      );
    } else if (card.cardType === "17" && card.itemType === "image") {
      return (
        <Card17Image2
          card={card}
          handleCategoryClick={handleCategoryClick}
        />
      );
    } else if (card.cardType === "18") {
      return <Card18Image card={card} />;
    }  else {
      return null;
    }

    // else if (card.cardType === "33" && card.itemType === "video_horizontal") {
    //   return <Card33VideoHorizontal card={card} />;
    // }
  };

  const handleBackButtonPress = () => {
    if (window.Android) {
      window.Android.onBackPressed();
    } else {
      navigate(-1);
    }
  };

  return view === "home" ? (
    <>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <ArrowBackIosIcon
          sx={{ cursor: "pointer" }}
          onClick={handleBackButtonPress}
        />
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
          GOQii Play
        </Typography>
      </Box> */}

      <PWAHeader title={"Live Coaching"} onBack={handleBackButtonPress} />

      <Box
        sx={{
          backgroundColor: "rgba(255, 152, 0, 0.11)",
          border: "1px solid #771615",
          width: "100%",
          overflowX: "hidden",
          padding: 2,
          boxSizing: "border-box",
        }}
      >
        {cards.map((card, idx) => (
          <Box key={idx}>{renderCardsByTypeAndItem(card)}</Box>
        ))}
        {isLoading && <LoadingScreenBlackLogo />}
      </Box>

      {/* Video Player Dialog */}
      {selectedVideo && (
        <Dialog
          open={Boolean(selectedVideo)}
          onClose={handleClosePlayer}
          fullScreen
          sx={{
            "& .MuiPaper-root": {
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)",
              borderRadius: "0px",
              backgroundColor: "#000",
            },
          }}
        >
          <VideoPlayer
  videoSrc={fixUrlProtocol(selectedVideo?.downloadUrl)}
  onClose={handleClosePlayer}
  title={selectedVideo?.title}
/>
        </Dialog>
      )}
    </>
  ) : view === "categories" ? (
    <CategoriesScreen
      typeId={selectedCategory?.typeId}
      type={selectedCategory?.type}
      displayName={selectedCategory?.displayName}
      
      onBack={() => setView("home")}
    />
  ) : (
    <StreamerProfile
      typeId={selectedProfile?.onTap.FAI?.typeId}
      type={selectedProfile?.onTap.FAI?.type}
      displayName={selectedProfile?.displayName}
      onBack={() => setView("home")}
    />
  );
};

export default GOQiiPlayScreen;